import { logWarn } from '@ardoq/logging';
import { PartialCSSStyleSheet } from './types';

const getCssRulesFromStylesheet = (stylesheet: PartialCSSStyleSheet) => {
  try {
    // if a style sheet is from the same domain, you will be able to access cssRules via JS,
    // otherwise Chrome will throw a CORS-related error (commented on March 16th, 2022)
    return Array.from(stylesheet.cssRules);
  } catch (error) {
    logWarn(error as Error, 'Failed to get css Rules');
    return [];
  }
};
export { getCssRulesFromStylesheet };
